<template>
    <div ref="chartRef" :style="`height: ${height || '300px'}`"></div>
</template>

<script>
    import * as echarts from 'echarts';

    export default {
        data: () => ({
            chart: null,
            observer: null
        }),
        props: {
            options: {
                type: Object,
                required: true
            },
            height: {
                type: String,
                default: '300px'
            }
        },
        mounted() {
            this.observer = new ResizeObserver(this.onResize);
            this.observer.observe(this.$el);

            setTimeout(() => {
                this.chart = echarts.init(this.$refs.chartRef, 'light');
                this.chart.setOption(this.$props.options);
            }, 500);
        },
        destroyed() {
            this.observer.disconnect();
        },
        methods: {
            onResize() {
                if (this.chart) {
                    this.chart.resize();
                }
            }
        }
    }
</script>
